// extracted by mini-css-extract-plugin
module.exports = {"notesModal":"Notes_notesModal__2bSLa","textArea":"Notes_textArea__1-2M4"};